import { retrieveErrorFromApi } from '../../../helper'
import { setAppErrors } from '../../action/system'
import { generateZReportPdf, buildZReportPdfFilename } from '../../../helper/zReportPdf'
import { savePdfOutput } from '../../../helper/pdfOutput/savePdfOutput'
import { appendZReports, setZReports, setZReportsForToday, setZReportsTotalLength, setZReportTestIsLoading, setZReportSavingPdf } from '../../action/zreport'
import { downloadFile } from '../../../helper/downloadFile'
import closeCashRegister from '../../axios/order/cashRegisterClose'
import getCashRegisterCloseZip from '../../axios/fiscal/get'
import fetchReports from '../../axios/fiscal/report'
import printReport from '../../axios/fiscal/report/print/post'
import getReportZip from '../../axios/fiscal/report/zip/post'
import createTestReport from '../../axios/fiscal/report/test/post'
import { getCashRegisterCloseDocumentation } from '../../axios/fiscal/getCashRegisterCloseDocumentation/ihdex'
import getRecordsFormatZDateVZip from '../../axios/report/z-datev'
import getRecordsFormat2ZDateVZip from '../../axios/report/z-datev-v4'
import getOrdersUnpaid from '../../axios/orderview/ordersUnpaid'
import { setUnpaidOrders, setUnpaidOrdersTotalLength } from '../../action/order'
import getCashRegisterCloseLast from '../../axios/order/cashRegisterCloseLast'
import { getDayStart } from '../unpaidOrders'

export const getZReportsThunk = (page, size, dateFrom, dateTo, zonedDateFrom, zonedDateTo) => dispatch => {
	return fetchReports(page, size, dateFrom, dateTo, zonedDateFrom, zonedDateTo)
		.then((res) => {
			if (res.headers['x-reports-total']) {
				dispatch(setZReportsTotalLength(parseInt(res.headers['x-reports-total'])))
			}
			if (page > 0 && size > 0) {
				dispatch(appendZReports(res.data))
				return
			}
			dispatch(setZReports(res.data))
		}).catch((error) => {
			dispatch(setAppErrors(retrieveErrorFromApi(error)))
		})
}

export const printZReportThunk = (reportId) => dispatch => {
	return printReport(reportId)
		.then(() => {
		}).catch((error) => {
			dispatch(setAppErrors(retrieveErrorFromApi(error)))
		})
}

export const createTestZReportThunk = () => (dispatch) => {
	return createTestReport()
		.then(() => {
		}).catch(error => {
			dispatch(setZReportTestIsLoading(false))
			dispatch(setAppErrors(retrieveErrorFromApi(error)))
		})
}

export const closeCashRegisterThunk = () => (dispatch) => {
	return closeCashRegister()
		.then(() => {
		}).catch(error => {
			dispatch(setAppErrors(retrieveErrorFromApi(error)))
		})
}

export const getCashRegisterCloseZipThunk = (dateFrom, dateTo, callback) => dispatch => {
	return getCashRegisterCloseZip(dateFrom, dateTo)
		.then(res => {
			downloadFile(res, 'DSFinV-K_' + dateFrom + '-' + dateTo + '.zip')
			callback()
		}).catch(error => {
			callback()
			dispatch(setAppErrors(retrieveErrorFromApi(error)))
		})
}

export const getZReportZipThunk = (reportId, zNumber) => dispatch => {
	return getReportZip(reportId)
		.then((res) => {
			downloadFile(res, 'DSFinV-K_' + zNumber + '.zip')
		}).catch((error) => {
			dispatch(setAppErrors(retrieveErrorFromApi(error)))
		})
}

export const getZReportsForTodayThunk = (page = 0, size, dateFrom, dateTo, zonedDateFrom, zonedDateTo) => dispatch => {
	return fetchReports(page, size, dateFrom, dateTo, zonedDateFrom, zonedDateTo)
		.then((res) => {
			dispatch(setZReportsForToday(res.data))
		}).catch((error) => {
			dispatch(setAppErrors(retrieveErrorFromApi(error)))
		})
}

export const getCashRegisterCloseDocumentationThunk = () => dispatch => {
	return getCashRegisterCloseDocumentation()
		.then((response) => {
			const nameFile = 'GoBD_Verfahrensdokumentation.zip'
			downloadFile(response, nameFile)
		})
		.catch(error => {
			dispatch(setAppErrors(retrieveErrorFromApi(error)))
		})
}

export const getRecordsFormatZDateVZipThunk = (dateFrom, dateTo, callback) => dispatch => {
	return getRecordsFormatZDateVZip(dateFrom, dateTo)
		.then(res => {
			downloadFile(res, 'DateVNew_' + dateFrom + '-' + dateTo + '.zip')
			callback()
		}).catch(error => {
			callback()
			dispatch(setAppErrors(retrieveErrorFromApi(error)))
		})
}

export const getRecordsFormat2ZDateVZipThunk = (dateFrom, dateTo, callback) => dispatch => {
	return getRecordsFormat2ZDateVZip(dateFrom, dateTo)
		.then(res => {
			downloadFile(res, 'DateVNew_V4_' + dateFrom + '-' + dateTo + '.zip')
			callback()
		}).catch(error => {
			callback()
			dispatch(setAppErrors(retrieveErrorFromApi(error)))
		})
}

export const getZReportUnpaidOrdersCountThunk = (dateFrom, dateTo) => async (dispatch) => {
	try {
		dispatch(setUnpaidOrders([]))
		dispatch(setUnpaidOrdersTotalLength(0))
		const res = await getOrdersUnpaid(dateFrom, dateTo)
		return res.data ? res.data.length : 0
	} catch (error) {
		dispatch(setAppErrors(retrieveErrorFromApi(error)))
		return 0
	}
}

export const getZReportUnpaidOrdersDateRangeThunk = () => async (dispatch) => {
	try {
		const res = await getCashRegisterCloseLast()
		const last = res.data || null
		const now = new Date()
		const dateFrom = last?.zTime ?? getDayStart(now.toISOString()).toISOString()
		const dateTo = now.toISOString()
		return { dateFrom, dateTo }
	} catch (error) {
		dispatch(setAppErrors(retrieveErrorFromApi(error)))
		return null
	}
}

export const saveZReportPdfThunk = (report, reportCashData, company, t, currencyLocale, currencyCode) => (dispatch) => {
	dispatch(setZReportSavingPdf(true))
	return generateZReportPdf(report, reportCashData, company, t, currencyLocale, currencyCode)
		.then(pdf => savePdfOutput(pdf, buildZReportPdfFilename(report)))
		.catch(() => dispatch(setAppErrors([{ message: t('Reports.ZReports.savePdfError') }])))
		.finally(() => dispatch(setZReportSavingPdf(false)))
}
